export default [
  {
    path: '/picLive/videoShare',
    meta: {},
    component: () =>
      import(/* webpackChunkName: 'picLive' */ '@/pages/picLive/VideoShare.vue')
  },
  {
    path: '/picLive/albumsShare',
    meta: {},
    component: () =>
      import(
        /* webpackChunkName: 'albumsShare' */ '@/pages/picLive/AlbumsShare.vue'
      )
  },
  {
    path: '/picLive/buyPicLive',
    meta: { title: '升级购买' },
    component: () =>
      import(
        /* webpackChunkName: 'buyPicLive' */ '@/pages/picLive/buyPicLive.vue'
      )
  }
]
